import { providerService } from '@/api'
// import active from './active'

const initialState = () => ({
  id: null,
  text: null
})

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async create({ state, rootState }, payload) {
      try {
        const result = await providerService.create(payload, {
          service: 'comments'
        })
        return result
      } catch (err) {
        console.error(err)
      }
    }
  },
  mutations: {
    assign(state, data) {
      state.all = data
    }
  }
}
